import { render, staticRenderFns } from "./JsonCompareComponent.vue?vue&type=template&id=0eb229fc&scoped=true&"
import script from "./JsonCompareComponent.vue?vue&type=script&lang=js&"
export * from "./JsonCompareComponent.vue?vue&type=script&lang=js&"
import style0 from "./JsonCompareComponent.vue?vue&type=style&index=0&id=0eb229fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb229fc",
  null
  
)

export default component.exports